import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { Box, IconButton, Paper, SvgIcon, Tooltip } from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';
import moment from "moment";
import { useMemo } from 'react';
import { tableConfig } from '../../commons/table/tableConfig';
import { StyledGestionDeObra } from '../../styled/Obras';

const GestionDeObraTableDetailsPanel = ({ data, onVerFormularioCargado, onVerCertificadoDePresentacion }) => {
  const columns = useMemo(() => [
    {
      accessorKey: 'idAvisoObra',
      header: 'Secuencia',
      Cell: ({ row }) => row.index + 1,
      size: 35,
    },
    {
      accessorKey: 'tipo',
      header: 'Tipo',
    },
    {
      accessorKey: 'fechaInicio',
      header: 'Fecha Inicio',
      Cell: ({ cell }) => cell.getValue() ? moment(cell.getValue()).format("DD/MM/YYYY") : '',
      filterFn: (row, id, filterValue) => {
        return row.original.fechaInicio
          ? moment(row.original.fechaInicio).format("DD/MM/YYYY").includes(filterValue)
          : false;
      },
      size: 50,
    },
    {
      accessorKey: 'fechaFin',
      header: 'Fecha Fin',
      Cell: ({ cell }) => cell.getValue() ? moment(cell.getValue()).format("DD/MM/YYYY") : '',
      filterFn: (row, id, filterValue) => {
        return row.original.fechaFin
          ? moment(row.original.fechaFin).format("DD/MM/YYYY").includes(filterValue)
          : false;
      },
      size: 50,
    },
    {
      accessorKey: 'fechaExtension',
      header: 'Fecha Extensión',
      Cell: ({ cell }) => cell.getValue() ? moment(cell.getValue()).format("DD/MM/YYYY") : '',
      filterFn: (row, id, filterValue) => {
        return row.original.fechaExtension
          ? moment(row.original.fechaExtension).format("DD/MM/YYYY").includes(filterValue)
          : false;
      },
      size: 50,
    },
    {
      accessorKey: 'fechaSuspension',
      header: 'Fecha Suspensión',
      Cell: ({ cell }) => cell.getValue() ? moment(cell.getValue()).format("DD/MM/YYYY") : '',
      filterFn: (row, id, filterValue) => {
        return row.original.fechaSuspension
          ? moment(row.original.fechaSuspension).format("DD/MM/YYYY").includes(filterValue)
          : false;
      },
      size: 50,
    },
    {
      accessorKey: 'fechaReinicio',
      header: 'Fecha Reinicio',
      Cell: ({ cell }) => cell.getValue() ? moment(cell.getValue()).format("DD/MM/YYYY") : '',
      filterFn: (row, id, filterValue) => {
        return row.original.fechaReinicio
          ? moment(row.original.fechaReinicio).format("DD/MM/YYYY").includes(filterValue)
          : false;
      },
      size: 40,
    },
    {
      accessorKey: 'portal',
      header: 'Cargado en Portal Web',
      size: 60
    },
  ], []);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: data || [],
    enableTopToolbar: false,
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enableFilters: false,
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
    },
    enableFilters: false,
    enableColumnFilterModes: false,
    enableColumnActions: false,
    enableSorting: false,
    enableRowActions: true,
    positionActionsColumn: 'last',
    renderRowActions: ({ row }) => (
      <Box sx={{ display: 'flex', gap: '8px' }}>
        <Tooltip title="Ver formulario cargado" placement="bottom" arrow>
          <IconButton
            onClick={() => onVerFormularioCargado(row.original)}
            sx={{ cursor: 'pointer' }}
          >
            <FolderOpenIcon color='info' />
          </IconButton>
        </Tooltip>
        {row.original.portal === "NO" ? (
          <Tooltip title="Certificado de Presentación" placement="bottom" arrow>
            <IconButton disabled>
              <StyledGestionDeObra.DisabledIcon
                component={StyledGestionDeObra.CertificadoPresentacionIcon}
              />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Certificado de Presentación" placement="bottom" arrow>
            <IconButton
              onClick={() => onVerCertificadoDePresentacion(row.original)}
              sx={{ cursor: 'pointer' }}
            >
              <SvgIcon component={StyledGestionDeObra.CertificadoPresentacionIcon} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
    // Fix width issues with these configurations
    muiTableContainerProps: {
      sx: {
        width: '100%',
        maxWidth: '100%'
      },
    },
    muiTableProps: {
      sx: {
        width: '100%',
        tableLayout: 'fixed'
      },
    },
    muiTableBodyProps: {
      sx: { width: '100%' }
    },
    layoutMode: 'grid',
  });

  return (
    <Paper width="100%">
      <MaterialReactTable table={table} />
    </Paper>
  );
};

export default GestionDeObraTableDetailsPanel;